import React,{useEffect,useState} from 'react';
import {useNavigate} from 'react-router-dom'
import {isMobile} from "../../helpers/browser_detect";
import Strings from '../../assets/strings'
import { FormControl, TableRow, TableCell, TableBody, Fab, Theme} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {mostrarSolicitudes} from "../../redux/reducers/solicitudesReducer";
import {formatDate, formatPeso, translateText} from "../../helpers";
import {
  HtmlTooltip,
  Pagination,
  TableSort,
  AppBar,
  SeacrhAppBar,
  FilteredAlert,
  MostrarError,
  LoadingProgress,
  ListViewMode, ButtonResponsive,
} from "../../components";
import {Link, EditOutlined, Share, CloudDownloadOutlined} from "@mui/icons-material";
import { SpeedDialAction, SpeedDial } from '@mui/material';
import downloadFiles from "../../helpers/downloadFiles";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {ISolicitudFilter} from "../../redux/types/ISolicitud";

const useStyles = makeStyles((theme:Theme) => ({
  root: {
    width: '100%',
    marginTop: 13,
    overflowX: 'auto',
  },
  selectEstado:{
    background: "transparent",
    border: "none",
    borderLeft: "1px solid #bdbdbd",
    padding: "3px 0px 0px 6px"
  },
  fb: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  speedDial:{
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  sDAction:{
    "& .MuiSpeedDialAction-staticTooltipLabel":{
      color: theme.palette.secondary.main,
      border: "1px solid " + theme.palette.secondary.main,
      boxShadow: "none",
      padding: "0px 10px",
      whiteSpace: "nowrap",
      fontSize: ".9rem",
    },
    "& svg":{
      color:theme.palette.primary.main,
    }

  }
}));

const initialState:ISolicitudFilter = {
  name:"",
  estado: undefined,
  page: 1,
  pageSize: 15,
  orderBy: "",
  orderByIsDescending:undefined,
}
export default function Solicitudes(){
  const classes = useStyles();

  let navigate = useNavigate();
  let dispatch = useAppDispatch();
  let userName = useAppSelector(state => state.auth?.user?.inicioSesion ?? "");
  let {list, status,error,filtered} = useAppSelector(state => state.solicitudes);

  const [open, setOpen] = useState(false);

  const [filter, setFilter] = useState(initialState);

  const isEmpty = !list?.items?.length;

  useEffect(() => {
    dispatch(mostrarSolicitudes());
  }, [dispatch]);
  //set filtered params
  useEffect(()=>setFilter({...initialState,...filtered}),[setFilter,filtered])


  const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    dispatch(mostrarSolicitudes({...filter,page:1,[name]:value}))
  };
  const tableSortProps = (orderBy:string) => {
    return {
      active:filter.orderBy === orderBy,
      direction: filter.orderByIsDescending ? "desc" : 'asc',
      onClick:()=>mostrarSolicitudes({...filter,page:1,orderBy,orderByIsDescending:!filter.orderByIsDescending})
    }
  };

 const url = `https://prestamistapp.com/solicitarCredito/${userName}`;//`https://prestamistapp.com/solicitar/${userName}`;

  return (

      <>
        <AppBar />


        <section className="contentInner" style={status === "loading"?{opacity:.8}:{opacity:1}}>
          {status === "loading" && <LoadingProgress vh/>}
          <MostrarError errors={error}/>

          <ListViewMode pageRows={list?.pageSize} pageTotalRows={list?.totalCount} noView>

            <SeacrhAppBar name="name" value={filter.name} onChange={handleFilter}/>
            <FormControl>
              <select
                  value={filter.estado}
                  onChange={(e)=>dispatch(mostrarSolicitudes({...filter,estado:parseInt(e.target.value)}))}
                  name = 'estado'
                  className={classes.selectEstado}
              >
                <option value="1">{Strings.pendiente}</option>
                <option value="2">{Strings.aprobada}</option>
                <option value="3">{Strings.rechazada}</option>
              </select>
            </FormControl>
            <ButtonResponsive icon={<CloudDownloadOutlined/>} text={Strings.exportar} disabled={isEmpty} onClick={()=>downloadFiles(filter,"solicitudes")}/>


            <FilteredAlert onClose={()=>dispatch(mostrarSolicitudes({}))} filter={filtered}/>
          </ListViewMode>

          <TableSort data={[
            {pro:"estado",text:Strings.estado},
            {pro:"fechaCreacion",text:Strings.fecha},
            {pro:"nombreCompleto",text:Strings.solicitante},
            {pro:"montoPrestamo",text:Strings.monto},
            {pro:"plazo",text:Strings.cuotas},
            {pro:"ciclosPago",text:Strings.modalidad},
            {pro:"cedula",text:Strings.cedula},
            {pro:"telefono",text:Strings.telefono},
            ...(filter.estado !== 1 ?
              [{pro:"fechaAprobacion",text:(filter.estado === 2?Strings.aprobada:Strings.rechazada)}]:[]
            ),
            {pro:"usuarioAgente",text:Strings.agentes},
          ]} onSort={tableSortProps} lessVh={144}>
            <TableBody>
            {!isEmpty && list?.items.map(sol =>
                <TableRow key={sol.id} onClick={()=>navigate(`/solicitud/${sol.id}`)}>
                  <TableCell>{translateText(sol.estadoString)}</TableCell>
                  <TableCell>{formatDate(sol.fechaCreacion)}</TableCell>
                  <TableCell>{sol.nombres} {sol.apellidos}</TableCell>
                  <TableCell>{formatPeso(sol.prestamoCapital)}</TableCell>
                  <TableCell>{sol.plazo}</TableCell>
                  <TableCell>{translateText(sol.ciclosPagoString)}</TableCell>
                  <TableCell>{sol.cedula}</TableCell>
                  <TableCell>{sol.telefono}</TableCell>
                  {filter.estado !== 1 &&
                    <TableCell>{formatDate(sol.fechaAprobacion)}</TableCell>
                  }
                  <TableCell>{sol.usuarioAgente}</TableCell>
                </TableRow>
            )}
            </TableBody>
          </TableSort>
          {!!list &&
              <Pagination
                  empty={Boolean(isEmpty && status !== "loading")}
                  count={list.totalCount || 0}
                  page={list.pageNumber - 1}
                  rowsPerPage={filter.pageSize??15}
                  onPageChange={(e, page) => {
                    dispatch(mostrarSolicitudes({...filter,page:page + 1}));
                  }}
                  onRowsPerPageChange={handleFilter}
              />
          }
        </section>
        {isMobile.anyWebView()?(
            <SpeedDial
                ariaLabel="Short Cut"
                className={classes.speedDial}
                icon={<Link/>}
                onClose={()=>setOpen(false)}
                onOpen={()=>setOpen(true)}
                open={open}
            >
              <SpeedDialAction
                  classes={{staticTooltip:classes.sDAction}}
                  icon={<Share/>}
                  tooltipTitle={"Compartir"}
                  tooltipOpen
                  FabProps={{
                    onClick: ()=>{

                      if((window as any).ReactNativeWebView) {
                        let ms = {
                          action: "shareLink",
                          payload:  {
                            caption:"Formulario de solicitud.",
                            url: url
                          }
                        }
                        return (window as any).ReactNativeWebView.postMessage(JSON.stringify(ms))

                      }else if(isMobile.AndroidWebView())
                        (window as any).Android.shareLink(url);
                      else if(isMobile.IosWebView())
                        (window as any).webkit.messageHandlers.shareLink.postMessage(url)
                      else
                        (window as any).open(url,'_blank');
                    }
                  }}
              />
              <SpeedDialAction
                  classes={{staticTooltip:classes.sDAction}}
                  icon={<EditOutlined/>}
                  tooltipTitle={"Abrir"}
                  tooltipOpen
                  FabProps={{
                    // @ts-ignore
                    component: "a",
                    target:"_blank",
                    rel:"noopener noreferrer",
                    href: url
                  }}
              />
            </SpeedDial>

        ):(
            <HtmlTooltip
                title={Strings.solicitudMsj}
            >
              <Fab color="primary" className={classes.fb} href={url} target={"_blank"} rel="noopener noreferrer">
                <Link />
              </Fab>
            </HtmlTooltip>
        )}
      </>
  );
}
